export function addBanHeroEnemy(hero){
    return{
        type:'ADD_BAN_HERO_ENEMY',
        payload:hero
    }
}